import {
  Box,
  Button,
  Center,
  Heading,
  Input,
  Link,
  Text,
} from "@chakra-ui/react";
import { Component } from "react";
import { BeatLoader } from "react-spinners";
import LoginFailed from "../Loader/LoginFailed";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import { setAdminlogin } from "../Services/AdminService";
import APIService from "../Services/APIService";
import { IBodyshopService } from "../UserService";
import "./../Common.css";
import "./Login.css";
import LoaderCommon from "../Loader/LoaderCommon";
import { Mixpanel } from "../Services/MixPanel";
import { LoginProps } from "../modals/PropInterface/LoginProps";
import { LoginState } from "../modals/StateInterface/LoginState";
import { CurrentUser } from "../modals/CurrentUser";
import { CommonMethodService } from "../Services/CommonMethodService";
import * as Sentry from "@sentry/react";

export default class Login extends Component<LoginProps, LoginState> {
  private ibsService: IBodyshopService;
  private apiService: APIService;
  private commonMethodService = new CommonMethodService();

  constructor(props: LoginProps) {
    super(props);
    this.state = {
      userName: "",
      password: "",
      showLoginLoader: false,
      isErrorDialog: false,
      errorDialogMessage: "Oops! Job not found.",
      estimateNumber: 0,
      customer: null,
      userId: null,
      showDialogLoad: true,
      showDialogForgotPassword: false,
      showLoader: false,
      estimateId: "",
      jobNumber: 0,
      isForgotPassword: false,
    };
    this.ibsService = new IBodyshopService();
    this.apiService = new APIService();
  }

  async componentDidMount() {
    this.load();
  }

  public async load() {
    const params = CommonMethodService.params();
    if (params["estimateid"]) {
      this.setState({ showLoader: true });
      await this.getEstimateData(params["estimateid"]);
      await this.getCustomerData(params["step"]);
      this.setState({ showLoader: false });
    }
  }

  public async getEstimateData(estimateNumber: string) {
    try {
      await this.ibsService
        .getEstimateDetailsById(estimateNumber)
        .then(async (result) => {
          if (result.ok) {
            const data = await result.json();
            this.setEstimateState(data);
          } else {
            this.setEstimateState(null);
            this.setErrorDialogMessage(
              true,
              "Something went wrong, Please reload the page or set proper estimateNumber"
            );
          }
        });
    } catch (ex) {
      this.setEstimateState(null);
      this.setErrorDialogMessage(
        true,
        "Something went wrong, Please reload the page or set proper estimateNumber"
      );
    }
  }

  public async getCustomerData(typeOfRequest: string) {
    if (
      !this.state.estimateNumber ||
      !this.state?.customer?.email ||
      !this.state.estimateId
    ) {
      this.setErrorDialogMessage(true, "Invalid Data, Please try it again");
      return;
    }
    await this.apiService
      .getCustomerData({
        externalId: this.state.estimateNumber.toString(),
        name: this.state.customer?.name,
        email: this.state.customer?.email,
        typeOfRequest,
      })
      .then(async (res) => {
        const result = await res.json();
        if (res.ok) {
          const data = result.data;
          if (!data.exist) {
            Mixpanel.identify(data.user?.id);
            Mixpanel.track("Register", {
              $email: data.user?.email,
              $name: data.user?.name,
              isActive: data?.isActive,
              $estimateId: data.user?.externalId,
              status: "Successfully Sent Request",
            });
            Mixpanel.people.set({
              $name: data.user?.name,
              $email: data.user?.email,
              $estimateId: data.user?.externalId,
            });

            this.changeLoginScreen(data);
          } else {
            if (!data.isActive) {
              this.setState({ isForgotPassword: true });
            }
          }
        } else {
          if (result.code === "ETIMEDOUT") {
            Sentry.captureException(result);
          }
          this.setMixPanelError("Register", result, res);
          this.setErrorDialogMessage(
            true,
            "Something went wrong, Please reload the page"
          );
        }
      })
      .catch((ex) => {
        Sentry.captureException(ex);
        console.log(ex);
        this.setErrorDialogMessage(
          true,
          "Something went wrong, Please reload the page"
        );
        this.setMixPanelError("Register", ex);
      });
  }

  async login() {
    if (this.state.userName === "" || this.state.password === "") {
      return;
    }
    this.setState({ showLoginLoader: true });
    if (
      this.state?.customer &&
      this.state?.customer?.email !== this.state?.userName
    ) {
      const urlWithoutQueryParams =
        window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, urlWithoutQueryParams);
    }
    const params = CommonMethodService.params();
    await this.apiService
      .login(this.state.userName, this.state.password, params["estimateid"])
      .then(async (res) => {
        const result = await res.json();
        if (res.ok) {
          this.changeLoginScreen(result);
        } else {
          if (result.code === "ETIMEDOUT") {
            Sentry.captureException(result);
          }
          this.setMixPanelError("Login", result, res);
          if (res.status === 400) {
            this.setErrorDialogMessage(true, "Incorrect email or password.");
          } else {
            this.setErrorDialogMessage(
              true,
              "Something went wrong, Please try again."
            );
          }

          this.props.ibsService.loggedIn = false;
        }
      })
      .catch((ex) => {
        Sentry.captureException(ex);
        this.props.ibsService.loggedIn = false;
        this.setErrorDialogMessage(
          true,
          "Something went wrong, Please try again."
        );
        this.setMixPanelError("Login", ex);
        return;
      });

    this.setState({ showLoginLoader: false });
  }

  changeLoginScreen(data: CurrentUser) {
    Mixpanel.identify(data.user.id);
    Mixpanel.track("Login", {
      email: data?.user?.email,
      status: "Successfully Login",
    });
    Mixpanel.people.set({
      $name: data?.user?.name,
      $email: data?.user?.email,
    });

    const isAdmin = data.user?.roles.find(
      (role: any) => role.name === "Administrator" || role.id === 6
    );
    if (isAdmin) {
      setAdminlogin(true);
    } else {
      setAdminlogin(false);
    }
    this.props.ibsService.currentUser = data;
    this.commonMethodService.setDataIntoStorage("currentUser", data);
    this.props.ibsService.loggedIn = true;
    this.props.loginSuccess();

    this.setState({ showLoginLoader: false });
  }

  setErrorDialogMessage(status: boolean, message: string) {
    this.setState({
      isErrorDialog: status,
      errorDialogMessage: message,
    });
  }

  setEstimateState(data: any) {
    this.setState({
      estimateNumber: data ? data.header.estimateNumber : null,
      customer: {
        name: data ? data.header.owner.contactDetails.displayName : null,
        email: data ? data.header.owner.contactDetails.emailAddress : null,
      },
      userName: data ? data.header.owner.contactDetails.emailAddress : "",
      estimateId: data ? data.header.id : null,
      jobNumber: data ? data.header.jobNumber : 0,
    });
  }

  setMixPanelError(type: string, result: any, response?: any) {
    Mixpanel.track(type + " Error", {
      name: this.state.customer?.name,
      email: this.state.customer?.email,
      error: result.errors ? result.errors : result,
      status: response ? response.status : "Exception Throw",
    });
  }
  closeErrorDialog() {
    this.setState({ isErrorDialog: false });
  }

  async reSendEmail() {
    this.setState({
      showDialogLoad: true,
    });
    if (this.state.userId) {
      await this.apiService.reSendEmail(this.state.userId);
    }
    this.setState({
      showDialogLoad: false,
    });
  }
  render() {
    return (
      <Center className="defaultBG">
        {this.state.showLoader ? (
          <LoaderCommon isLoginLoader={false} loadingText={""} />
        ) : undefined}
        {this.state.showDialogForgotPassword && (
          <ForgotPassword
            closeModal={() =>
              this.setState({ showDialogForgotPassword: false })
            }
          />
        )}

        {this.state.isErrorDialog ? (
          <LoginFailed
            errorTitle={this.state.errorDialogMessage}
            closeDialog={this.closeErrorDialog.bind(this)}
          />
        ) : (
          <Box
            maxW={["sm", null, "4xl"]}
            p={12}
            bg="white"
            boxShadow="lg"
            m="auto"
            borderRadius="md"
          >
            <div className="row">
              <div>
                <Heading>Customer Portal</Heading>
                <Heading fontSize={"md"} className="loginDetail">
                  Stay on top of your repairs
                </Heading>
              </div>
              <Box mt={8}>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.login();
                  }}
                >
                  <Input
                    variant="filled"
                    type="email"
                    placeholder="Username"
                    name="Username"
                    value={this.state.userName}
                    onChange={(e) => {
                      this.setState({ userName: e.currentTarget.value });
                    }}
                  />
                  <Input
                    mt={2}
                    variant="filled"
                    placeholder="Password"
                    type="password"
                    name="jobid"
                    value={this.state.password}
                    onChange={(e) => {
                      this.setState({ password: e.currentTarget.value });
                    }}
                  />

                  <div className="logInBtnParent">
                    <Button
                      isLoading={this.state.showLoginLoader}
                      colorScheme="blue"
                      spinner={<BeatLoader size={8} color="white" />}
                      size="lg"
                      w={"100%"}
                      mt={4}
                      onClick={() => this.login()}
                      type="submit"
                    >
                      Log In
                    </Button>
                  </div>
                </form>
                {/* <form className="form"> */}

                {/*</form>*/}

                <Box mt={12} w="100%">
                  {this.state.isForgotPassword ? (
                    <Box className="mb-2">
                      <Text fontSize={"medium"} fontWeight={"medium"}>
                        Your password was auto generated.
                      </Text>
                      <Text fontSize={"medium"} fontWeight={"medium"}>
                        Please{" "}
                        {
                          <Link
                            style={{ textDecoration: "underline" }}
                            onClick={() =>
                              this.setState({ showDialogForgotPassword: true })
                            }
                          >
                            Forgot your password
                          </Link>
                        }{" "}
                        to log in.
                      </Text>
                    </Box>
                  ) : (
                    <Link
                      style={{ textDecoration: "underline" }}
                      onClick={() =>
                        this.setState({ showDialogForgotPassword: true })
                      }
                    >
                      Forgot your password
                    </Link>
                  )}
                  <Box>
                    <Text fontSize={"medium"} fontWeight={"medium"}>
                      Having trouble signing in?
                    </Text>
                    <Text fontSize={"medium"} fontWeight={"medium"}>
                      Contact customer support at{" "}
                      {
                        <Link
                          style={{ textDecoration: "underline" }}
                          href="mailto:hello@flowautobody.com.au"
                        >
                          hello@flowautobody.com.au
                        </Link>
                      }
                    </Text>
                  </Box>
                </Box>
                {/* </form> */}
              </Box>
            </div>
          </Box>
        )}
      </Center>
    );
  }
}
